import {Button} from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import {useTranslation} from 'react-i18next';
import MiniTable from '../../components/mini-table';
import useFormatter from '../../hooks/useFormatter';

export default function ResumoTable({ dataSource, loading, miniTableRef, title }) {
  const { t } = useTranslation();
  const { formatDateTime, formatBytes } = useFormatter();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);


  const tipoTabela = useMemo(() => {
  if (!dataSource || dataSource.length === 0) return "modulos";
  const sample = dataSource[0];


  if ("qtdArmazenamento" in sample) return "armazenamentos";
  if ("modulo" in sample && !("qtdAlertas" in sample)) return "tarefas";
  return "modulos";
  }, [dataSource]);


useEffect(() => {
const interval = setInterval(() => {
setWindowHeight(window.innerHeight);
}, 300);

  return () => clearInterval(interval);
}, []);


  const columns = useMemo(() => {
    if (tipoTabela === "armazenamentos") {
      return [
        {
    title: t("ID"),
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: t("Ambiente ID"),
    dataIndex: "ambienteId",
    key: "ambienteId",
    width: 100,
  },
  {
    title: t("Ambiente"),
    dataIndex: "ambienteNome",
    key: "ambienteNome",
    width: 150,
  },
  {
    title: t("Acesso ID"),
    dataIndex: "acessoId",
    key: "acessoId",
    width: 100,
  },
  {
    title: t("Acesso"),
    dataIndex: "acessoNome",
    key: "acessoNome",
    width: 150,
  },
  {
    title: t("Empresa ID"),
    dataIndex: "empresaId",
    key: "empresaId",
    width: 100,
  },
  {
    title: t("Empresa"),
    dataIndex: "empresaNome",
    key: "empresaNome",
    width: 200,
  },
  {
    title: t("Qtd. Anexos"),
    dataIndex: "qtdAnexos",
    key: "qtdAnexos",
    align: "center",
    width: 120,
  },
  {
    title: t("Armazenamento (bytes)"),
    dataIndex: "qtdArmazenamento",
    key: "qtdArmazenamento",
    align: "center",
    width: 180,
    render: (value) => formatBytes(value),
  },
  {
    title: t("Criado em"),
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (_, record) => formatDateTime(record.createdAt),
  },
  {
    title: t("Atualizado em"),
    dataIndex: "updatedAt",
    key: "updatedAt",
    width: 180,
    render: (_, record) => formatDateTime(record.updatedAt),
  },
      ];
    }

    if (tipoTabela === "tarefas") {
  return [
    {
      title: t("ID"),
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: t("Ambiente ID"),
      dataIndex: "ambienteId",
      key: "ambienteId",
      width: 100,
    },
    {
      title: t("Ambiente"),
      dataIndex: "ambienteNome",
      key: "ambienteNome",
      width: 150,
    },
    {
      title: t("Acesso ID"),
      dataIndex: "acessoId",
      key: "acessoId",
      width: 100,
    },
    {
      title: t("Acesso"),
      dataIndex: "acessoNome",
      key: "acessoNome",
      width: 150,
    },
    {
      title: t("Empresa ID"),
      dataIndex: "empresaId",
      key: "empresaId",
      width: 100,
    },
    {
      title: t("Empresa"),
      dataIndex: "empresaNome",
      key: "empresaNome",
      width: 200,
    },
    {
      title: t("Módulo"),
      dataIndex: "modulo",
      key: "modulo",
      width: 120,
    },
    {
      title: t("Tarefas abertas"),
      dataIndex: "qtdTarefasAbertas",
      key: "qtdTarefasAbertas",
      align: "center",
      width: 150,
    },
    {
      title: t("Tarefas"),
      dataIndex: "qtdTarefas",
      key: "qtdTarefas",
      align: "center",
      width: 150,
    },
    {
      title: t("Criado em"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 180,
      render: (_, record) => formatDateTime(record.createdAt),
    },
    {
      title: t("Atualizado em"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 180,
      render: (_, record) => formatDateTime(record.updatedAt),
    },
  ];
    }


  return [
    {
    title: t("ID"),
    dataIndex: "id",
    key: "id",
    width: 80,
  },
  {
    title: t("Ambiente ID"),
    dataIndex: "ambienteId",
    key: "ambienteId",
    width: 100,
  },
  {
    title: t("Ambiente"),
    dataIndex: "ambienteNome",
    key: "ambienteNome",
    width: 150,
  },
  {
    title: t("Acesso ID"),
    dataIndex: "acessoId",
    key: "acessoId",
    width: 100,
  },
  {
    title: t("Acesso"),
    dataIndex: "acessoNome",
    key: "acessoNome",
    width: 150,
  },
  {
    title: t("Empresa ID"),
    dataIndex: "empresaId",
    key: "empresaId",
    width: 100,
  },
  {
    title: t("Empresa"),
    dataIndex: "empresaNome",
    key: "empresaNome",
    width: 200,
  },
  {
    title: t("Módulo"),
    dataIndex: "modulo",
    key: "modulo",
    width: 120,
  },
  {
    title: t("Em dia"),
    dataIndex: "qtdEmdia",
    key: "qtdEmdia",
    align: "center",
    width: 100,
  },
  {
    title: t("Alertas"),
    dataIndex: "qtdAlertas",
    key: "qtdAlertas",
    align: "center",
    width: 100,
  },
  {
    title: t("Pendências"),
    dataIndex: "qtdPendencias",
    key: "qtdPendencias",
    align: "center",
    width: 120,
  },
  {
    title: t("Criado em"),
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (_, record) => formatDateTime(record.createdAt),
  },
  {
    title: t("Atualizado em"),
    dataIndex: "updatedAt",
    key: "updatedAt",
    width: 180,
    render: (_, record) => formatDateTime(record.updatedAt),
  },
  ];
  }, [tipoTabela, t, formatDateTime]);

  return (
    <MiniTable
      key={windowHeight}
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      scroll={{ x: "max-content", y: windowHeight - 350 }} 
    />
  );
}


ResumoTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
